import {ChangeDetectionStrategy, Component, contentChildren, effect, input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {SidenavItemComponent} from '../sidenav-item/sidenav-item.component';
import {SidenavItemsGroupComponent} from '../sidenav-items-group/sidenav-items-group.component';
@Component({
	selector: 'dc-sidenav-section',
	imports: [TranslateModule],
	styles: `
		:host {
			@apply px-1 py-2 flex flex-col gap-0.5;
		}

		.section-title {
			@apply text-xs font-semibold text-gray-500;
		}
	`,
	template: `
		@if (sectionTitle()) {
			<div class="section-title">{{ sectionTitle() | translate }}</div>
		}

		<ng-content />
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavSectionComponent {
	public readonly items = contentChildren(SidenavItemComponent, {descendants: true});
	public readonly itemsGroups = contentChildren(SidenavItemsGroupComponent, {descendants: true});

	/* ------------------------------------------  Types and Constants ------------------------------------------ */

	/* ------------------------------------------ PROVIDERS / SERVICES ------------------------------------------ */

	/* ------------------------------------------------  Inputs ------------------------------------------------ */
	public readonly section = input.required<'top' | 'bottom'>();
	public readonly sectionTitle = input<string | undefined>(undefined);
	/* ------------------------------------------------  Outputs ------------------------------------------------ */

	/* ------------------------------------------------  Signals ------------------------------------------------ */

	/* -------------------------------------------------- Data -------------------------------------------------- */

	/* ------------------------------------------------  Constructor ------------------------------------------------ */
	constructor() {
		// effect(() => {
		// 	const d = {
		// 		groupIds: this.itemsGroups().map(item => item.id()),
		// 		items: this.items().map(item => ({
		// 			id: item.id(),
		// 			groupId: item.parentGroup?.id(),
		// 		})),
		// 	};
		// 	console.log(this.section(), d);
		// });
	}

	/* ----------------------------------------------- Lifecycle Hooks ----------------------------------------------- */

	/* ------------------------------------------------  Methods ------------------------------------------------ */
}
